function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { getNextSlidesCount, getPreviousSlidesCount } from "../utils/index";
var actionReducer = function(state, action) {
    switch(action.type){
        case 'next':
            return _objectSpread({}, state, {
                slideIndex: state.slideIndex + 1
            });
        case 'previous':
            return _objectSpread({}, state, {
                slideIndex: state.slideIndex - 1
            });
        case 'set-slide-count':
            return _objectSpread({}, state, {
                slideCount: action.value,
                slideIndex: 0,
                slideLabels: Array(action.value).fill(false)
            });
        case 'set-col-count':
            return _objectSpread({}, state, {
                cols: action.value
            });
        case 'set-slide-index':
            return _objectSpread({}, state, {
                slideIndex: action.value
            });
        case 'set-slide-labels':
            {
                var _value = action.value, label = _value.label, index = _value.index;
                var slideLabels = state.slideLabels;
                return _objectSpread({}, state, {
                    slideLabels: _toConsumableArray(slideLabels.slice(0, index)).concat([
                        label
                    ], _toConsumableArray(slideLabels.slice(index + 1)))
                });
            }
        default:
            throw new Error("Unknown action: ".concat(action));
    }
};
var nextPreviousReducer = function(state) {
    return _objectSpread({}, state, {
        nextSlidesCount: getNextSlidesCount(state),
        previousSlidesCount: getPreviousSlidesCount(state)
    });
};
export var reducer = function(prevState, action) {
    return [
        actionReducer,
        nextPreviousReducer
    ].reduce(function(newState, _reducer) {
        return _reducer(newState, action);
    }, prevState);
};
export default reducer;
